import {ColumnIndex, IGridCell, RowIndex} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';
import {GridModelView} from '@mintdata-wsp/wsp/ui/components/grid/GridModelView';

export class TransposedGridModelView extends GridModelView
{
    getCellAt(rowIndex:RowIndex, columnIndex:number):IGridCell|null
    {
        return super.getCellAt(columnIndex, rowIndex);
    }

    getRow(rowIndex:RowIndex):IGridCell[]
    {
        return super.getColumn(rowIndex);
    }

    getColumn(columnIndex:ColumnIndex):IGridCell[]
    {
        return super.getRow(columnIndex);
    }

    getNumRows():number
    {
        return super.getNumColumns();
    }

    getNumColumns():number
    {
        return super.getNumRows();
    }

    public getAllRowsHeight():number
    {
        return super.getAllColumnsWidth();
    }

    public getRowHeight(rowIndex:RowIndex):number
    {
        return super.getColumnWidth(rowIndex);
    }

    public setRowHeight(rowIndex:RowIndex, newHeight:number):void
    {
        super.setColumnWidth(rowIndex, newHeight);
    }

    public isRowSelected(rowIndex:RowIndex):boolean
    {
        throw new Error('unsupported on transposed grid model view');
    }

    public setIsRowSelected(rowIndex:RowIndex, isSelected:boolean):void
    {
        throw new Error('unsupported on transposed grid model view');
    }

    public getAllColumnsWidth():number
    {
        return super.getAllRowsHeight();
    }

    public getColumnWidth(columnIndex:ColumnIndex):number
    {
        return super.getRowHeight(columnIndex);
    }

    public setColumnWidth(columnIndex:ColumnIndex, newWidth:number):void
    {
        super.setRowHeight(columnIndex, newWidth);
    }
}


